<template>
  <div id="cesium_container">

    <div :class="['mock-btn', sidebarOpen ? 'expand' : 'collapse']" :title="sidebarOpen ? '收起' : '展开'" style="top: 5px;" @click="toggleSidebar">
      <i :class="sidebarOpen ? 'el-icon-arrow-left' : 'el-icon-arrow-right'" style="color: #fff;"></i>
    </div>

    <el-popover placement="left" trigger="click" ref="popover">
      <el-button v-for="(item, index) in publicScripts" :key="item.label" :type="item.type"
        @click="handleScript(index)">
        {{ item.label }}
      </el-button>

      <div class="mock-btn" title="公共脚本" slot="reference" style="top: calc(5px + 32px + 8px);right: 5px;">
        <img src="@/assets/images/js.svg" alt="">
      </div>
    </el-popover>

    <CustomDrawer :visible.sync="drawerOpen" :title="curScript?.label">
      <CodeBrower :code="curScript?.value || ''" language="javascript" :maxHeight="maxHeight" />
    </CustomDrawer>

    <PointDirect />
    <PointInteract />

    <ArcDirect />
    <ArcInteract />

    <CurveDirect />
    <CurveInteract />

    <PolylineDirect />
    <PolylineInteract />

    <FreeHandPolylineDirect />
    <FreeHandPolylineInteract />

    <CircleDirect />
    <CircleInteract />

    <ElliseDirect />
    <EllipseInteract />

    <LuneDirect />
    <LuneInteract />

    <SectorDirect />
    <SectorInteract />

    <RectDirect />
    <RectInteract />

    <ClosedCurveDirect />
    <ClosedCurveInteract />

    <PolygonDirect />
    <PolygonInteract />

    <FreeHandPolygonDirect />
    <FreeHandPolygonInteract />

    <GatheringPlaceDirect />
    <GatheringPlaceInteract />

    <DoubleArrowDirect />
    <DoubleArrowInteract />

    <StraightArrowDirect />
    <StraightArrowInteract />

    <FineArrowDirect />
    <FineArrowInteract />

    <AssaultDirectionDirect />
    <AssaultDirectionInteract />

    <AttackArrowDirect />
    <AttackArrowInteract />

    <TailedAttackArrowDirect />
    <TailedAttackArrowInteract />

    <SquadCombatDirect />
    <SquadCombatInteract />

    <TailedSquadCombatDirect />
    <TailedSquadCombatInteract />

  </div>
</template>

<script>
import { PlotUtilsScript } from "./Panels/tools";
import { useFixedScript } from "./Panels/useFixed";
import { useUnfixedScript } from "./Panels/useUnfixed";
import { mapState } from "vuex";

export default {
  name: 'Earth',
  components: {
    CustomDrawer: () => import("./CustomDrawer.vue"),
    CodeBrower: () => import("./CodeBrower.vue"),
    PointDirect: () => import("./Panels/point/Direct.vue"),
    PointInteract: () => import("./Panels/point/Interact.vue"),
    ArcDirect: () => import("./Panels/arc/Direct.vue"),
    ArcInteract: () => import("./Panels/arc/Interact.vue"),
    CurveDirect: () => import("./Panels/curve/Direct.vue"),
    CurveInteract: () => import("./Panels/curve/Interact.vue"),
    PolylineDirect: () => import("./Panels/polyline/Direct.vue"),
    PolylineInteract: () => import("./Panels/polyline/Interact.vue"),
    FreeHandPolylineDirect: () => import("./Panels/freeHandPolyline/Direct.vue"),
    FreeHandPolylineInteract: () => import("./Panels/freeHandPolyline/Interact.vue"),
    CircleDirect: () => import("./Panels/circle/Direct.vue"),
    CircleInteract: () => import("./Panels/circle/Interact.vue"),
    ElliseDirect: () => import("./Panels/ellipse/Direct.vue"),
    EllipseInteract: () => import("./Panels/ellipse/Interact.vue"),
    LuneDirect: () => import("./Panels/lune/Direct.vue"),
    LuneInteract: () => import("./Panels/lune/Interact.vue"),
    SectorDirect: () => import("./Panels/sector/Direct.vue"),
    SectorInteract: () => import("./Panels/sector/Interact.vue"),
    RectDirect: () => import("./Panels/rectangle/Direct.vue"),
    RectInteract: () => import("./Panels/rectangle/Interact.vue"),
    ClosedCurveDirect: () => import("./Panels/closedCurve/Direct.vue"),
    ClosedCurveInteract: () => import("./Panels/closedCurve/Interact.vue"),
    PolygonDirect: () => import("./Panels/polygon/Direct.vue"),
    PolygonInteract: () => import("./Panels/polygon/Interact.vue"),
    FreeHandPolygonDirect: () => import("./Panels/freeHandPolygon/Direct.vue"),
    FreeHandPolygonInteract: () => import("./Panels/freeHandPolygon/Interact.vue"),
    GatheringPlaceDirect: () => import("./Panels/gatheringPlace/Direct.vue"),
    GatheringPlaceInteract: () => import("./Panels/gatheringPlace/Interact.vue"),
    DoubleArrowDirect: () => import("./Panels/doubleArrow/Direct.vue"),
    DoubleArrowInteract: () => import("./Panels/doubleArrow/Interact.vue"),
    StraightArrowDirect: () => import("./Panels/straightArrow/Direct.vue"),
    StraightArrowInteract: () => import("./Panels/straightArrow/Interact.vue"),
    FineArrowDirect: () => import("./Panels/fineArrow/Direct.vue"),
    FineArrowInteract: () => import("./Panels/fineArrow/Interact.vue"),
    AssaultDirectionDirect: () => import("./Panels/assaultDirection/Direct.vue"),
    AssaultDirectionInteract: () => import("./Panels/assaultDirection/Interact.vue"),
    AttackArrowDirect: () => import("./Panels/attackArrow/Direct.vue"),
    AttackArrowInteract: () => import("./Panels/attackArrow/Interact.vue"),
    TailedAttackArrowDirect: () => import("./Panels/tailedAttackArrow/Direct.vue"),
    TailedAttackArrowInteract: () => import("./Panels/tailedAttackArrow/Interact.vue"),
    SquadCombatDirect: () => import("./Panels/squadCombat/Direct.vue"),
    SquadCombatInteract: () => import("./Panels/squadCombat/Interact.vue"),
    TailedSquadCombatDirect: () => import("./Panels/tailedSquadCombat/Direct.vue"),
    TailedSquadCombatInteract: () => import("./Panels/tailedSquadCombat/Interact.vue"),
  },

  data() {
    return {
      drawerOpen: false,
      publicScripts: [
        { type: 'success', label: '工具函数 (P.PlotUtils)', value: PlotUtilsScript },
        { type: 'primary', label: '固定点数图形-公共方法', value: useFixedScript },
        { type: 'primary', label: '无数点数图形-公共方法', value: useUnfixedScript },
      ],
      curScript: {}
    }
  },

  computed: {
    ...mapState(['sidebarOpen']),
    maxHeight() {
      return parseFloat(innerHeight) - 32 - 16 - 16 * 2 - 44;
    }
  },

  mounted() {
    this.initEarth();
  },

  beforeDestroy() {
    if (window.viewer) {
      window.viewer.destroy();
      window.viewer = null;
    }
  },

  methods: {
    initEarth() {
      Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiY2ExNmYyOC0yYjk5LTRjOGMtYTI0ZC0xZmFmMDAwMzhlZDUiLCJpZCI6NTI1MjgsImlhdCI6MTYxODY2NjE5N30.ETTMOAYLjTMplvAxKehiZCrzT1o2s--bFqREAOSP3fg';
      const viewer = new Cesium.Viewer('cesium_container', {
        infoBox: false,//不设为false会报错
        geocoder: false,//右上角搜索按钮
        navigationHelpButton: false,//右上角帮助按钮
        selectionIndicator: false,//点击后地图上显示的选择控件
        baseLayerPicker: false,//右上角图层选择器
        showRenderLoopErrors: false,//HTML面板中显示错误信息
        fullscreenButton: true,//右下角全屏按钮
        sceneModePicker: true,//右上角2D和3D之间的切换
        scene3DOnly: false, // 改为false以启用2D/3D切换
        timeline: false, // 页面下方的时间条
        homeButton: false,
        animation: false, // 左下角圆盘 速度控制器
        imageryProvider: false,
        terrainProvider: false
      });

      // 移除 Cesium 默认的影像图层
      viewer.imageryLayers.removeAll();

      // 添加影像图层
      viewer.imageryLayers.addImageryProvider(
        window.APP_CONFIG.online_map ?
          new Cesium.ArcGisMapServerImageryProvider({
            url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
            enablePickFeatures: false,
          }) :
          new Cesium.UrlTemplateImageryProvider({
            url: window.APP_CONFIG.urltemplate_api + `{${window.APP_CONFIG.first}}/{${window.APP_CONFIG.second}}/{${window.APP_CONFIG.third}}.` + window.APP_CONFIG.format,
            tilingScheme: window.APP_CONFIG.urltemplate_epsg === "4326" ? new Cesium.GeographicTilingScheme() : new Cesium.WebMercatorTilingScheme(),
            maximumLevel: window.APP_CONFIG.max_zoom || 6
          })
      );

      // 添加全球地形
      viewer.terrainProvider = window.APP_CONFIG.online_map ?
        Cesium.createWorldTerrain({
          requestVertexNormals: true,
          requestWaterMask: true
        }) :
        new Cesium.CesiumTerrainProvider({
          url: window.APP_CONFIG.terrain_api, // 自定义地形服务的 URL
        });

      // 地形夸张
      viewer.scene.globe.terrainExaggeration = 10;

      // 关闭大气散射
      viewer.scene.skyAtmosphere.show = false;

      // 关闭太阳光照
      viewer.scene.sun.show = false;

      //隐藏 商标版权与数据源
      viewer.cesiumWidget.creditContainer.style.display = 'none';

      // 设置相机的初始视图
      viewer.camera.setView({
        destination: Cesium.Cartesian3.fromDegrees(100, 30, 5000000),
      });

      window.viewer = viewer;
    },

    handleScript(idx) {

      this.curScript = this.publicScripts.length > idx ? this.publicScripts[idx] : {};

      // 1. 先让当前活动元素失去焦点，转移到 body 或其他安全元素
      if (document.activeElement && document.activeElement.blur) {
        // 解决 aria-hidden="true" 警告
        document.activeElement.blur();
      }

      // 2. 再关闭 Popover
      this.$refs.popover.doClose();

      // 3. 打开抽屉
      this.drawerOpen = true;
    },

    toggleSidebar() {
      this.$store.commit('SET_SIDEBAR_OPEN', !this.sidebarOpen);
    }
  }// methods end
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

#cesium_container {
  height: 100vh;
  flex: 1;

  .mock-btn {
    position: absolute;
    z-index: 1;
    padding: 4px;

    margin: 0 3px;
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #303336;
    border: 1px solid #444;
    border-radius: 14%;
    cursor: pointer;

    &:hover {
      background: #48b;
      border-color: #aef;
      box-shadow: 0 0 8px #fff;
    }

    img {
      width: 100%;
    }

    &.collapse {
      left: 5px;
    }

    &.expand {
      left: calc(#{$sidebar-width} + 5px);
    }
  }
}
</style>